import React, { useState } from "react";
import { Button, Form, Modal, Grid, Message } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

const RejectModal = (props) => {
  const [reason, setReason] = useState("");

  return (
    <Modal
      open={props.open}
      onClose={() => {
        props.updateRejectModal();
      }}
      className="modalHOTFIX"
    >
      <Modal.Header>{props.t("RejectModal.rejectBooking")}</Modal.Header>
      <Modal.Content>
        <Form warning={props.hasChargedPayment}>
          <Grid>
            {props.hasChargedPayment && (
              <Grid.Row>
                <Grid.Column>
                  <Message warning>
                    <Message.Header>
                      {props.t("RejectModal.chargedBookingWarningTitle", "User Has Already Been Charged")}
                    </Message.Header>
                    <p>
                      {props.t(
                        "RejectModal.chargedBookingWarningBody",
                        "This user has already been charged for this booking. Rejecting will issue a full refund to their card."
                      )}
                    </p>
                  </Message>
                </Grid.Column>
              </Grid.Row>
            )}
            <Grid.Row>
              <Grid.Column>
                <Form.Field>
                  <label>{props.t("RejectModal.rejectReasoning")}</label>
                  <textarea
                    value={reason}
                    onChange={(e) => {
                      setReason(e.target.value);
                      props.updateReason(e.target.value);
                    }}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button
                  onClick={() => props.updateRejectModal()}
                  color="red"
                  floated="right"
                >
                  {props.t("general.close")}
                </Button>
                <Button
                  onClick={(e) => {
                    props.updateApproved({
                      id: props.bookingId,
                      approved: "rejected",
                      reason,
                    });
                    setReason("");
                    props.updateRejectModal();
                  }}
                  color="green"
                  floated="right"
                >
                  {props.t("general.reject")}
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Modal.Content>
    </Modal>
  );
};

export default withTranslation()(RejectModal);
